<template>
    <div class="Membershippackage">
        <main class="MainContent">
            <el-button type="primary" style="margin-bottom: 10px;" @click="dialogVisible=true">新增会员套餐</el-button>

            <el-table
            :data="PackageData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%;margin-bottom: 20px;">
                <el-table-column prop="PackageName" label="套餐名称"></el-table-column>
                <el-table-column label="套餐时长" :formatter="(row)=> {return row.packageDuration+'月'}"></el-table-column>
                <el-table-column prop="PackagePrice" label="价格"></el-table-column>
                <el-table-column prop="purchaseFrequency" label="购买人数"></el-table-column>
                <el-table-column label="是否上架">
                    <template slot-scope="scope">
                        <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.arrive" @change="ClickEdit(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="是否默认">
                    <template slot-scope="scope">
                        <el-switch :active-value="1" :inactive-value="0" v-model="scope.row.isDefault" @change="ClickEdit(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-right: 10px;" @click="ClickdiaEdit(scope.row)">编辑</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.MemberPackageId)">
                            <el-button type="text" style="color: #F24B4E;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>


        <el-dialog
            title="新增会员套餐"
            :visible.sync="dialogVisible"
            width="520px"
            center
            :before-close="handleClose">
            <el-form label-width="80px" label-position="left">
                <el-form-item label="套餐名称">
                    <el-input type="text" v-model="ADDparams.PackageName" placeholder="请输入套餐名称，如：月度会员" clearable class="autowidth" maxlength="30" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="套餐时长">
                    <el-input type="number" v-model="ADDparams.packageDuration" placeholder="请输入套数" clearable class="autowidth">
                        <template slot="append">月</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="实际价格">
                    <el-input type="number" v-model="ADDparams.PackagePrice" placeholder="请输入实际价格" clearable class="autowidth">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="划线价格">
                    <el-input type="number" v-model="ADDparams.UnderlinedPrice" placeholder="请输入划线价格" clearable class="autowidth">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input type="number" v-model="ADDparams.sort" placeholder="" clearable class="autowidth"></el-input>
                </el-form-item>
                <el-form-item label="是否上架">
                    <el-switch :active-value="1" :inactive-value="0" v-model="ADDparams.arrive"></el-switch>
                </el-form-item>
                <el-form-item label="是否默认">
                    <el-switch :active-value="1" :inactive-value="0" v-model="ADDparams.isDefault"></el-switch>
                </el-form-item>
                <el-form-item >
                    <el-button @click="handleClose">取消</el-button>
                    <el-button type="primary" @click="saveSubmit()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default{
    data() {
        return {
            idedit:false,
            issubmit:true,
            loading:false,
            dialogVisible:false,
            memberPackageId:'',
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0
            },
            ADDparams:{
                PackageName: "",//套餐名称
                packageDuration: 1,//套餐时长（月）
                PackagePrice: 1,//套餐价格(元)
                arrive: 1,//是否上架
                isDefault: 1,//是否默认
                sort: 1,//排序
            },
            PackageData:[]
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            this.loading=true;
            this.$Http_Post('/kg/package/list',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.param.PageTotal=res.Counts;
                    this.PackageData=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
        },
        ClickdiaEdit(val){
            this.idedit=true;
            this.dialogVisible=true;
            this.ADDparams={
                MemberPackageId:val.MemberPackageId,
                PackageName:val.PackageName,//套餐名称
                packageDuration:val.packageDuration,//套餐时长（月）
                PackagePrice:val.PackagePrice,//套餐价格(元)
                UnderlinedPrice:val.UnderlinedPrice,
                arrive:val.arrive,//是否上架
                isDefault: val.isDefault,//是否默认
                sort: val.sort,//排序
            }
        },
        // 编辑
        ClickEdit(e){
            this.$Http_Post('/kg/package/edit',{MemberPackageId:e.MemberPackageId,PackageName:e.PackageName,packageDuration:e.packageDuration,PackagePrice:e.PackagePrice,UnderlinedPrice:e.UnderlinedPrice,arrive:e.arrive,isDefault:e.isDefault,sort:e.sort}).then(res=>{
                if(res.Code==0){
                    this.init();
                    this.$message.success("修改成功");
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 删除
        confirm(e){
            this.$Http_Post('/kg/package/remove/'+e).then(res=>{
                if(res.Code==0){
                    this.init();
                    this.$message.success(res.Message);
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        saveSubmit(){
            if(this.issubmit){
                this.issubmit=false;
                this.$Http_Post(this.idedit?'/kg/package/edit':'/kg/package/add',this.ADDparams).then(res=>{
                    if(res.Code==0){
                        this.ADDparams=this.$options.data().ADDparams;
                        this.$message.success(res.Message);
                        this.init();
                        this.dialogVisible=false;
                    }else{
                        this.$message.error(res.Message);
                    }
                    this.idedit=false;
                    this.issubmit=true;
                })
            }else{
                this.$message.error("请勿重复提交");
            }
            
        }

    },
}
</script>
<style>
.Membershippackage .autowidth{width: 260px;}
.Membershippackage .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
.Membershippackage .el-dialog--center{border-radius: 16px;padding: 20px 0 0;}
</style>